import {useLocation, useParams} from 'react-router-dom';

import './careplan.scss';
import {useLegacyInit} from './api';
import {verifyIsValidEncounterId, mapFieldCase} from './utils/legacy-data';

import {useUserStore} from 'user/store';

/**
 * This component is responsible for initializing the React props for
 * the Care Plan and Encounter Note views ported from PPUI.
 *
 * Any children to it should probably be lazy imported to avoid issues
 * accessing windows.initReactProps before it is set.
 */
const PPUIInitReactProps = ({children}) => {
    const {username} = useParams();
    const {id: orgId} = useUserStore(state => state.activeOrg);

    /**
     * Get the encounterId from the URL path, if there is one, and pass it
     * so that we get the correct encounter note config.
     */
    const {pathname} = useLocation();
    const encounterId = pathname.split('encounters/')[1] ?? '';

    const {data, isLoading, error} = useLegacyInit({
        orgId,
        username,
        ...(verifyIsValidEncounterId(encounterId) && {encounterId}),
    });

    if (!data?.data || isLoading || !!error) return;
    window.initReactProps = mapFieldCase(data.data);
    // Without this, the app will not render
    if (!window.initReactProps) {
        return;
    }

    return <>{children}</>;
};

export default PPUIInitReactProps;
